export const TAB_LIST = [
  { label: 'Status', id: 0 },
  { label: 'Product Type', id: 1 },
  { label: 'Avg Turn', id: 2 },
  { label: 'SLA %', id: 3 },
  { label: 'Avg Claim Price', id: 4 },
  { label: 'Closed %', id: 5 },
  { label: 'Call/Chat Global', id: 6 },
  { label: 'Email 24 hr SLA Global', id: 7 },
  { label: 'AUDIT LOGS', id: 8 },
];

export const STATUS_COLORS = {
  Completed: '#4AA225',
  Closed: '#C8CDD7',
  InProgress: '#FFA500',
  Pending: '#A6D2FE',
};

export const STATUS_LABELS = {
  Completed: 'Completed',
  Closed: 'Closed',
  InProgress: 'In Progress',
  Pending: 'Pending',
};

export const CLOSURE_REASON_COLORS = {
  Others: '#A6D2FE',
  'Poor Images': '#589DFA',
  'No Images': '#B4BAC7',
};

export const CLOSED_PERCENTAGE_COLOR = '#1859D4';

export const AVG_TURN_COLORS = {
  Completed: '#589DFA',
  Closed: '#B4BAC7',
};

export const AVG_TURN_LINE_COLOR = '#199239';

export const PENDING_REASONS_LABLES = {
  NeedToID: 'Need To ID',
  SiteMap: 'Site Map',
  ReportTypeChange: 'Report Type Change',
};

export const PENDING_REASONS_COLORS = {
  NeedToID: '#589DFA',
  SiteMap: '#A6D2FE',
  ReportTypeChange: '#B4BAC7',
};
